
<div class="otp-container">
  <div class="otp-container-main">
    <div class="top-heading mt-2">
      <h5 class="m-0">{{'field.label.quick_download_verification_code' | translate | async }}</h5>
    </div>
    <div class="mt-2">
      <!-- <p>We have sent you 6 digit verification code on your mobile to verify contact details.</p> -->
      <p>{{'field.label.quick_otp' | translate | async }}</p>
    </div>
    <app-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config">
    </app-otp-input>

    <div class="col-12 p-0 mt-4">
      <button class="login-button btn-gradient button-hover text-white" (click)="verifyOtp()">
        {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
      aria-hidden="true"></i>
    </button>
  </div>

  <div class="col-12 mt-1 p-0">
    @if (!showTimer) {
      <span class="cLink" (click)="resendOTP()">{{'field.label.resend_OTP' | translate | async }}</span>
    }
    @if (showTimer) {
      <span class="timer" style="cursor: not-allowed; color: gray;">
        {{'field.label.resend_OTP_in_timer_sec' | translate | async }} {{timer}} {{'field.label.seconds' | translate | async}}
      </span>
    }
  </div>
</div>
</div>